import React from 'react';
import { useLongPress } from 'use-long-press';
import { Link } from 'react-router';
import withGoBack from '../../common/withGoBack';
import Bugsnag from '../../helpers/bugsnag';
import { shorten } from '../../common/globals';

const SetRow = ({
  item, setsQty, index, onEditSets, onLongPress
}) => {
  let setQtyModal = null;

  const listSelect = ((position) => {
    if (position === null) {
      return 'selected';
    }
    return '';
  });

  const _onEditSets = (event, setsIndex, itemIndex, data) => {
    try {
      event.stopPropagation();
      if (setsQty[data.SetName] >= 0) {
        setQtyModal = new window.bootstrap.Modal(window.$('#setQtyModal'));
        setQtyModal.show();
        onEditSets(setsQty[data.SetName], data, 'no');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onSelectSet = (setsIndex, itemIndex, data) => {
    try {
      const qty = setsQty[data.SetName] && setsQty[data.SetName] >= 1 ? 0 : 1;
      onEditSets(qty, data, setsQty[data.SetName] >= 1 ? 'remove' : 'add');
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const longPressBind = useLongPress((event) => {
    if (event.target.getAttribute('data') !== null) {
      onLongPress(item.children[Number(event.target.getAttribute('data'))]);
    } else {
      onLongPress(item.children[Number(event.target.getAttribute('id'))]);
    }
  }, { threshold: 2000, captureEvent: true });

  return (
    <div className="sets-block cursor-pointer">
      <h4 id={item.group.toLowerCase()}>{item.group}</h4>
      <ul className="list-unstyled" key={index}>
        {
          item.children.map((data, key) => (
            <Link onClick={() => { _onSelectSet(index, key, data); }} key={key}>
              <li
                {...longPressBind}
                id={key}
                className={`${setsQty[data.SetName] > 0 ? 'selected' : listSelect(key)}`}
                style={{ borderBottom: '1px solid #757575', borderTop: '0' }}
              >
                <div
                  className="left-side"
                  onClick={(event) => _onEditSets(event, index, key, data)}
                >
                  {setsQty[data.SetName] > 0 ? <span className="count">{shorten(setsQty[data.SetName], 5)}</span> : <i className="fas fa-plus theme-color" />}
                </div>
                <div className="right-side">
                  <p data={key}>{data.SetName} <br /> {data.hasOwnProperty('ECSetDescription') && data.ECSetDescription}</p>
                </div>
              </li>
            </Link>
          ))
        }
      </ul>
    </div>
  );
};

export default withGoBack(SetRow);
